<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.controlDoctors', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @reset="onReset" v-if="show">
                    <b-container>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="nom-group"
                                        :label="$t('message.lastName')"
                                        label-for="nom"
                                        description=""
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.user.nom.$model"
                                            :state="$v.form.user.nom.$dirty ? !(errorshasField('nom') || $v.form.user.nom.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('nom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.user.nom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                        {{ getErrorsField('nom') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">
                                <b-form-group
                                        id="prenom-group"
                                        :label="$t('message.firstName')"
                                        label-for="prenom"
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.user.prenom.$model"
                                            type="text"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="telephone-group"
                                        :label="$t('message.phoneNumber')"
                                        label-for="telephone"
                                >
                                    <b-form-input
                                            id="telephone"
                                            v-model="$v.form.user.telephone.$model"
                                            :state="$v.form.user.telephone.$dirty ? !(errorshasField('telephone') || $v.form.user.telephone.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('telephone')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.user.telephone.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.user.telephone.integer">
                                        {{ $t('message.integer', { n: 9 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="!$v.form.user.telephone.minLength">
                                        {{ $t('message.minCharacters', { n: 9 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('telephone')">
                                        {{ getErrorsField('telephone') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>


                                <b-form-group
                                        id="email-group"
                                        :label="$t('message.email')"
                                        label-for="email"
                                >
                                    <b-form-input
                                            id="email"
                                            v-model="$v.form.user.email.$model"
                                            :state="$v.form.user.email.$dirty ? !(errorshasField('email') || $v.form.user.email.$error) : null"
                                            type="email"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('email')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.user.email.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                        {{ $t('message.emailNotValid') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                        {{ getErrorsField('email') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="specialty-group"
                                        :label="$tc('message.specialties', 1)"
                                        label-for="specialty">
                                    <b-form-select
                                            id="specialty"
                                            v-model="$v.form.specialite_id.$model"
                                            :state="$v.form.specialite_id.$dirty ? !(errorshasField('specialite_id') || $v.form.specialite_id.$error) : null"
                                            :options="mSpecialties"
                                            required
                                            @focus="clearErrorField('specialite_id')"
                                    ></b-form-select>

                                    <b-form-invalid-feedback v-if="!$v.form.specialite_id.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('specialite_id')">
                                        {{ getErrorsField('specialite_id') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="numero-group"
                                        :label="$t('message.orderNumber')"
                                        label-for="numero"
                                >
                                    <b-form-input
                                            id="numero"
                                            v-model="$v.form.numero_ordre.$model"
                                            :state="$v.form.numero_ordre.$dirty ? !(errorshasField('numero_ordre') || $v.form.numero_ordre.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('numero_ordre')"
                                    ></b-form-input>

<!--                                    <b-form-invalid-feedback v-if="!$v.form.numero_ordre.required">-->
<!--                                        {{ $t('message.requiredField') }}-->
<!--                                    </b-form-invalid-feedback>-->

                                    <b-form-invalid-feedback v-if="errorshasField('numero_ordre')">
                                        {{ getErrorsField('numero_ordre') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.numero_ordre.minLength">
                                        {{ $t('message.minCharacters', { n: 6 }) }}
                                    </b-form-invalid-feedback>


                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="civility-group"
                                        :label="$t('message.civility')"
                                        label-for="civility">
                                    <b-form-select
                                            id="civility"
                                            v-model="$v.form.civilite.$model"
                                            :state="$v.form.civilite.$dirty ? !(errorshasField('civilite') || $v.form.civilite.$error) : null"
                                            :options="civilites"
                                            required
                                            @focus="clearErrorField('civilite')"
                                    ></b-form-select>

                                    <b-form-invalid-feedback v-if="!$v.form.civilite.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('civilite')">
                                        {{ getErrorsField('civilite') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="nationalite-group"
                                        :label="$t('message.nationality')"
                                        label-for="nationalite"
                                >
                                    <b-form-input
                                            id="nationalite"
                                            v-model="form.user.nationalite"
                                            :state="$v.form.user.nationalite.$dirty ? !(errorshasField('nationalite') || $v.form.user.nationalite.$error) : null"
                                            @focus="clearErrorField('nationalite')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('nationalite')">
                                        {{ getErrorsField('nationalite') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="singlePays-group"
                                        :label="$t('message.select')+' '+$tc('message.countries', 1)"
                                        label-for="singlePays">
                                    <!-- Options -->
                                    <select id="singlePays"  v-model="form.user.pays" required>
                                        <option v-for="item in mCountries" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="errorshasField('pays')">
                                        {{ getErrorsField('pays') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.pays.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>


                                </b-form-group>

                            </b-col>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="ville-group"
                                        :label="$tc('message.cities', 1)"
                                        label-for="ville"
                                >
                                    <b-form-input
                                            id="ville"
                                            v-model="form.user.ville"
                                            :state="$v.form.user.ville.$dirty ? !(errorshasField('ville') || $v.form.user.ville.$error) : null"
                                            @focus="clearErrorField('ville')"
                                            required
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('ville')">
                                        {{ getErrorsField('ville') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.ville.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="street-group"
                                        :label="$t('message.street')"
                                        label-for="street"
                                >
                                    <b-form-input
                                            id="street"
                                            v-model="form.user.quartier"
                                            :state="$v.form.user.quartier.$dirty ? !(errorshasField('quartier') || $v.form.user.quartier.$error) : null"
                                            @focus="clearErrorField('quartier')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('quartier')">
                                        {{ getErrorsField('quartier') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="zipCode-group"
                                        :label="$t('message.zipCode')"
                                        label-for="zipCode"
                                >
                                    <b-form-input
                                            id="zipCode"
                                            v-model="form.user.code_postal"
                                            :state="$v.form.user.code_postal.$dirty ? !(errorshasField('code_postal') || $v.form.user.code_postal.$error) : null"
                                            @focus="clearErrorField('code_postal')"
                                            type="number"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('code_postal')">
                                        {{ getErrorsField('code_postal') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="address-group"
                                        :label="$t('message.address')"
                                        label-for="address"
                                >
                                    <b-form-input
                                            id="address"
                                            v-model="form.user.adresse"
                                            :state="$v.form.user.adresse.$dirty ? !(errorshasField('adresse') || $v.form.user.adresse.$error) : null"
                                            @focus="clearErrorField('adresse')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('adresse')">
                                        {{ getErrorsField('adresse') }}
                                    </b-form-invalid-feedback>

<!--                                    <b-form-invalid-feedback v-if="!$v.form.user.adresse.required">-->
<!--                                        {{ $t('message.requiredField') }}-->
<!--                                    </b-form-invalid-feedback>-->
                                </b-form-group>

                            </b-col>
                            <b-col sm="4">

                                <b-form-group
                                        id="slack-group"
                                        :label="$t('message.slack')"
                                        label-for="slack"
                                >
                                    <b-form-input
                                            id="slack"
                                            v-model="$v.form.user.slack.$model"
                                            :state="$v.form.user.slack.$dirty ? !(errorshasField('slack') || $v.form.user.slack.$error) : null"
                                            @focus="clearErrorField('slack')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('slack')">
                                        {{ getErrorsField('slack') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3" v-if="userIsMed">
                                <div>
                                    <label class="form__label" for="hasDesc">{{$t('message.isMedPatner')}}</label>
                                    <div class="toggle">
                                        <input id="hasDesc" type="checkbox" v-model="form.user.isMedicasure"/>
                                        <label for="hasDesc">
                                            <div class="toggle__switch"></div>
                                        </label>
                                    </div>
                                </div>
                            </b-col>
                            <b-col sm="3" v-if="userIsMed">
                                <div>
                                    <label class="form__label" for="hasDesc2">{{$t('message.userIsNotice')}}</label>
                                    <div class="toggle">
                                        <input id="hasDesc2" type="checkbox" v-model="form.user.isNotice"/>
                                        <label for="hasDesc2">
                                            <div class="toggle__switch"></div>
                                        </label>
                                    </div>
                                </div>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group
                                        id="upload-group"
                                        :label="$t('message.uploadFile')"
                                        label-for="upload"
                                >
                                    <b-form-file
                                            id="upload"
                                            :state="$v.form.signature.$dirty ? !$v.form.signature.$error : null"
                                            :placeholder="$t('message.uploadFile')"
                                            :file-name-formatter="formatNames"
                                            @change="setImage"
                                    ></b-form-file>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

<!--                            <b-col sm="6">-->
<!--                                <b-container fluid class="p-4">-->
<!--                                    <b-row id="image">-->
<!--                                        <b-col>-->
<!--                                            <b-img-lazy-->
<!--                                                    class="img-preview"-->
<!--                                                    thumbnail-->
<!--                                                    :src="imageSrc(form.signature)"-->
<!--                                                    fluid-grow-->
<!--                                                    alt=""-->
<!--                                            ></b-img-lazy>-->
<!--                                        </b-col>-->
<!--                                    </b-row>-->
<!--                                </b-container>-->
<!--                            </b-col>-->
                        </b-row>

                    </b-container>

                    <b-container>

                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button  @click="onSubmit" variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>
                        </b-row>

                    </b-container>

                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, email, minLength,integer } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';
    import AppConfig from '../../constants/AppConfig';


    export default {
        name: "EditControlDoctor",

        computed: {
            ...mapGetters(["controlDoctor", "countries", "specialties", "errors",'hasAdminRole','hasAssistante',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
            },
            form: function() {
                return this.controlDoctor;
            },

            userIsMed:function(){
                return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
            },

            mCountries: function() {
                let cArray = [];

                _.forOwn(this.countries, function(value, key) {
                    cArray.push({ text: value.name, value: value.name });
                });

                return cArray;
            },

            mSpecialties: function() {
                let sArray = [];

                _.forOwn(this.specialties, function(value, key) {
                    sArray.push({ text: value.name, value: value.id });
                });

                return sArray;
            }
        },

        data() {
            return {
                doctor_id: this.$route.params.doctor,
                show: true,
                civilites: [
                    { value: 'Mme/Mlle.', text: 'Mme/Mlle.' },
                    { value: 'M.', text: 'M.' },
                    { value: 'Dr.', text: 'Dr.' },
                    { value: 'Pr.', text: 'Pr.' }
                ]
            }
        },

        methods: {

            formatNames(files) {
                return files[0].name
            },

            setImage(event) {
                this.form.signature = event.target.files[0];
            },

            imageSrc(img) {
                if (img) {
                    try {
                        return URL.createObjectURL(img);
                    } catch(e) {
                        return AppConfig.imgUrl + '/public/storage/' + img;
                    }
                }

                return '';
            },

            getDoctor: function() {
                let args = {
                    doctor: this.doctor_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getControlDoctor', { args, errorMessages });
            },

            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },

            getSpecialties: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getSpecialties', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let formData = new FormData();

                    formData.append('doctor', this.doctor_id);
                    formData.append('nom', this.form.user.nom);
                    formData.append('prenom', this.form.user.prenom);
                    formData.append('specialite_id', this.form.specialite_id);
                    formData.append('email', this.form.user.email);
                    formData.append('telephone', this.form.user.telephone);
                    formData.append('numero_ordre', _.isNull(this.form.numero_ordre) ? '' : this.form.numero_ordre );
                    formData.append('civilite', this.form.civilite);
                    formData.append('nationalite', this.form.user.nationalite);
                    formData.append('ville', this.form.user.ville);
                    formData.append('adresse', this.form.user.adresse);
                    formData.append('pays', this.form.user.pays);
                    formData.append('quartier', this.form.user.quartier);
                    formData.append('slack', this.form.user.slack);
                    formData.append('code_postal', this.form.user.code_postal);
                    formData.append('signature', this.form.signature);
                    formData.append('isMedicasure', this.form.user.isMedicasure ? '1' : '0');
                    formData.append('isNotice', this.form.user.isNotice ? '1' : '0');

                    let successMessage = this.$i18n.t('message.controlDoctorUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateControlDoctor', { args:formData,doctor: this.doctor_id, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.user.nom = '';
                this.form.specialite_id = '';
                this.form.user.email = '';
                this.form.user.telephone = '';
                this.form.numero_ordre = '';
                this.form.civilite = '';
                this.form.user.nationalite = '';
                this.form.user.ville = '';
                this.form.user.pays = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                user: {
                    nom: {
                        required
                    },
                    prenom: {
                        //
                    },
                    telephone: {
                        required,
                        integer,
                        minLength: minLength(9)
                    },
                    isMedicasure:{

                    },
                    isNotice:{

                    },
                    email: {
                        required,
                        email
                    },
                    nationalite: {
                        //
                    },
                    ville: {
                        required
                    },
                    quartier: {
                        //
                    },
                    code_postal: {
                        //
                    },
                    pays: {
                        required
                    },
                    adresse: {
                        // required
                    },
                    slack: {

                    }
                },

                specialite_id: {
                    required
                },

                numero_ordre: {
                    // required,
                    // integer,
                    // minLength: minLength(4)
                },

                civilite: {
                    required
                },

                signature:{

                }

            }
        },

        mounted() {
            // Retrieve control doctor
            this.getDoctor();

            // Retrieve list of countries
            this.getCountries();

            // Retrieve list of specialties
            this.getSpecialties();

            new SlimSelect({
                select: '#singlePays',
                placeholder: 'Select Country'
            })
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>